module.exports = __webpack_public_path__ + "static/media/acquisto-api.cfe4a448.gif";